import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import store from '@/store'
import token from '@/utils/storage/token'

let url = process.env.VUE_APP_BASE_URL ? process.env.VUE_APP_BASE_URL : 'https://api.space.studio-luck.com.ua';
axios.defaults.baseURL = url + '/api/'
Vue.prototype.$baseURL = url
axios.interceptors.response.use((response) => {
  return response
}, (error) => {
  if (error.response.status === 401) {
    if(error.response.data == "Feature not allowed.") {
      router.push({path: "/error-page"})
      console.error("Feature not allowed.")
    }
    if(error.response.data.message == "Unauthenticated.") {
      token.remove()
      store.commit('setUser', false)
      router.push({path: "/login"})
    }
  }

  return Promise.reject(error.response.data)
})

let auth = token.get()
if (auth) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + auth
}
